/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MyProfile
 */
export interface MyProfile {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    email: string;
    /**
     * 
     */
    avatar: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    pushTokens: Array<string>;
}

/**
 * Check if a given object implements the MyProfile interface.
 */
export function instanceOfMyProfile(value: object): value is MyProfile {
    if ((!('id' in (value as Record<string, any>)) && !('_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['id'] === undefined && (value as Record<string, any>)['_id'] === undefined)) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('avatar' in value) || value['avatar'] === undefined) return false;
    if (!('pushTokens' in value) || value['pushTokens'] === undefined) return false;
    return true;
}

export function MyProfileFromJSON(json: any): MyProfile {
    return MyProfileFromJSONTyped(json, false);
}

export function MyProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['_id'],
        'email': json['email'],
        'avatar': json['avatar'],
        'name': json['name'] == null ? undefined : json['name'],
        'pushTokens': json['pushTokens'],
    };
}

export function MyProfileToJSON(json: any): MyProfile {
    return MyProfileToJSONTyped(json, false);
}

export function MyProfileToJSONTyped(value?: MyProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['id'],
        'email': value['email'],
        'avatar': value['avatar'],
        'name': value['name'],
        'pushTokens': value['pushTokens'],
    };
}

